import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EmpInfo } from '../model/emp.model';
import { TimeSheetSummaryWorkListReturn } from '../model/reportTimesheetSummary.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';

@Component({
  selector: 'app-timesheet-summary-worklist',
  templateUrl: './timesheet-summary-worklist.component.html',
  styleUrls: ['./timesheet-summary-worklist.component.css']
})
export class TimesheetSummaryWorklistComponent implements OnInit {

  baseurl: string;

  //Search Conditions
  txtSchEmployee: string = "";
  txtSchMonthFrom: string = "";
  txtSchMonthTo: string = "";
  txtSchYear: string = "";

  ListYear: string[] = [];

  TimeSheetSummaryWorkListList: TimeSheetSummaryWorkListReturn[] = [];

  //Label describing the criteria that produced the current result set
  searchResultLabel: string = '';

  ListMonth = [
    { Code: "1", Name: "Jan" },
    { Code: "2", Name: "Feb" },
    { Code: "3", Name: "Mar" },
    { Code: "4", Name: "Apr" },
    { Code: "5", Name: "May" },
    { Code: "6", Name: "Jun" },
    { Code: "7", Name: "Jul" },
    { Code: "8", Name: "Aug" },
    { Code: "9", Name: "Sep" },
    { Code: "10", Name: "Oct" },
    { Code: "11", Name: "Nov" },
    { Code: "12", Name: "Dec" }
  ];

  //empselect
  employeeselectrun: boolean = false;
  selectedemp: EmpInfo[] = [];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit(): void {
    this.LoadYearList();
  }

  // OnEvent - start
  // ========================================================================================================
  async OnSearch_Click() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson: any = {};
      objectjson['SearchEmpCode'] = this.selectedemp.length > 0 ? [this.selectedemp[0].EmpCode] : [];
      objectjson['MonthFrom'] = this.txtSchMonthFrom;
      objectjson['MonthTo'] = this.txtSchMonthTo;
      objectjson['Year'] = this.txtSchYear;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetSummaryWorkListReturn[]>(this.baseurl + "TimeSheet/TimeSheetSummaryWorkList", strjson, httpOptions)
        .subscribe({
          next: data => {
            console.log(data)
            this.TimeSheetSummaryWorkListList = data;
            this.searchResultLabel = this.buildSearchResultLabel();
          }
        });
    }
  }

  OnClearSearch_Click() {
    this.txtSchEmployee = "";
    this.selectedemp = [];
    this.txtSchMonthFrom = "";
    this.txtSchMonthTo = "";
    this.txtSchYear = "";
    this.TimeSheetSummaryWorkListList = [];
    this.searchResultLabel = '';
  }

  private buildSearchResultLabel(): string {
    const emp = this.txtSchEmployee;
    const monthFrom = this.ListMonth.find(m => m.Code === this.txtSchMonthFrom)?.Name ?? '';
    const monthTo = this.ListMonth.find(m => m.Code === this.txtSchMonthTo)?.Name ?? '';
    const year = this.txtSchYear;
    return `${emp} \u00A0\u00A0\u00A0 Month From: ${monthFrom} - Month To: ${monthTo} \u00A0\u00A0\u00A0 Year: ${year}`;
  }
  // OnEvent - end
  // ========================================================================================================

  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadYearList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson: any = {};
      objectjson['EmpCode'] = window.localStorage.getItem('EmpCode');

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<any>(this.baseurl + "TimeSheet/TimeSheetYearUsed", strjson, httpOptions)
        .subscribe({
          next: data => {
            console.log(data)
            this.ListYear = data[0]?.YearList ?? [];
          }
        });
    }
  }
  // Primary-Data Functions - end
  // ========================================================================================================

  // Footer sum - start
  // ========================================================================================================
  get TotalHoursSum(): number {
    return this.TimeSheetSummaryWorkListList.reduce((sum, i) => sum + (i.TotalHours || 0), 0);
  }

  get ActualDayVSPlanDaySum(): string {
    let actualSum = 0;
    let planDate = 0;

    this.TimeSheetSummaryWorkListList.forEach((i, index) => {
      const parts = (i.ActualDayVSPlanDay || '').split('/');
      actualSum += parseFloat(parts[0]) || 0;
      if (index === 0) planDate = parseFloat(parts[1]) || 0;
    });

    return actualSum.toFixed(2) + ' / ' + planDate;
  }
  // Footer sum - end
  // ========================================================================================================

  selectedEmp(event) {
    this.selectedemp = event;
  }

  empselect() {
    this.employeeselectrun = true;
    this.txtSchEmployee = ""
    this.selectedemp = [];
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {
    $('#ModalEmpSelect').modal('hide');
    this.employeeselectrun = false;

    this.txtSchEmployee = this.selectedemp.length > 0
      ? this.selectedemp[0].EmpCode + ' - ' + this.selectedemp[0].EmpFname_TH + ' ' + this.selectedemp[0].EmpLname_TH
      : ''
  }

}
